export class ValidationUtils {
  static USERNAME_PATTERN = '^[a-zA-Z0-9]([,@=_\\.\\-\\/]?[a-zA-Z0-9]){2,}';
  static PHONE_PATTERN = '^[0-9+(][0-9()#.\\s\\/ext-]{9,}$';
  static PASSWORD_PATTERN = '^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{12,}$';
  static EMAIL_GROUP_PATTERN = '^([^@\\s]+)?(@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,})$'
}
